import { render } from "./EditShipmentComponent.vue?vue&type=template&id=60733324&scoped=true"
import script from "./EditShipmentComponent.vue?vue&type=script&lang=js"
export * from "./EditShipmentComponent.vue?vue&type=script&lang=js"

import "./EditShipmentComponent.vue?vue&type=style&index=0&id=60733324&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60733324"]])

export default __exports__